// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1879":"69f70b87","2207":"f000548f","4408":"06fa47ea","5159":"69f70b87"}[chunkId] + ".chunk.css";
};